module.exports = __webpack_public_path__ + "img/4.6.CODm.334d412f.png";